module.exports = __webpack_public_path__ + "img/add-product-images.b2c1fa2f.svg";